import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import {
  getCustomerUsersSuccess,
  getCustomerUsersFailure,
  getCustomersSuccess,
  getCustomersFailure,
  getActivationKeyDetailsSuccess,
  loadMoreCustomerUsersSuccess,
  getOnlineCustomersSuccess,
  getOnlineCustomersFailure,
} from 'src/Actions/Customers/customerAction';
import {
  loadingAction,
  stopLoadingAction,
} from 'src/Actions/Generic/genericActions';
import {
  getCustomerUsersApi,
  getCustomerList,
  getActivationKeyInfo,
  getOnlineCustomersApi,
} from 'src/Services/Customer/customerApi';
import { findIfSingleAccount } from 'src/Actions/Admin/adminActions';

// Constants
import { CUSTOMER } from '../../Actions/Customers/types';

// Saga handlers
export default function* customerSaga() {
  yield takeLatest(CUSTOMER.GET_CUSTOMER_USERS, handleGetCustomerUsers);
  yield takeLatest(CUSTOMER.GET_CUSTOMERS, fetchCustomerDetails);
  yield takeEvery(CUSTOMER.GET_ACTIVATION_KEY_DETAILS, fetchActivationKeyInfo);
  yield takeEvery(CUSTOMER.GET_ONLINE_CUSTOMERS, fetchOnlineCustomers);
}

/**
 * @param { payload: { activationKey, pagenumber, limit, searchKey } } payload
 */
export function* handleGetCustomerUsers({ payload, loadMore }) {
  try {
    if (!!loadMore) {
      let response = yield call(getCustomerUsersApi, payload);
      if (response && response.status === 200 && response.data) {
        let data = response.data;
        yield put(loadMoreCustomerUsersSuccess(data));
      }
    } else {
      yield put(loadingAction());
      let response = yield call(getCustomerUsersApi, payload);
      if (response && response.status === 200 && response.data) {
        let data = response.data;
        yield put(getCustomerUsersSuccess(data));
      }
      yield put(stopLoadingAction());
    }
  } catch (e) {
    yield put(getCustomerUsersFailure(e));
  }
}

export function* fetchCustomerDetails({ payload }) {
  try {
    let response = yield call(getCustomerList, payload);
    if (response && response.status === 200 && response.data) {
      let temp =
        response.data &&
        response.data.subscriptionLicenseList &&
        response.data.subscriptionLicenseList.length > 0
          ? response.data.subscriptionLicenseList
          : [];
          let val = temp.length === 1
          ? true
          : false;
      let isSingleAccount =
        (payload.searchKey === '' || payload.searchKey === undefined) &&
        temp &&
        temp.length > 0
          ? val
          : false;
      yield put(getCustomersSuccess(response.data));
      yield put(findIfSingleAccount(isSingleAccount));
    }
  } catch (e) {
    yield put(getCustomersFailure(e));
  }
}

export function* fetchActivationKeyInfo({ activationKey }) {
  try {
    let response = yield call(getActivationKeyInfo, activationKey);
    if (response && response.status === 200 && response.data) {
      yield put(getActivationKeyDetailsSuccess(response.data));
    }
  } catch (e) {
    console.log(e);
  }
}
/**
 * @param { payload: { sort } } payload
 */
export function* fetchOnlineCustomers({ payload }) {
  try {
    let response = yield call(getOnlineCustomersApi, payload);
    if (response && response.status === 200 && response.data) {
      yield put(getOnlineCustomersSuccess(response.data));
    }
  } catch (e) {
    yield put(getOnlineCustomersFailure(e));
  }
}
